export const config = {
  itemsPerPage: 50,
  partnerFleetsItemsPerPage: 100, // TODO: some partners already have above 50 fleets. We need to rethink implementation once 100 is not enough anymore
  devicesPerPage: 20,
  alertSuccessTimeOut: 4000,
  passwordRedirectionURL: "https://itsmybike.cloud/users/edit",
  customerCareEmail: "fleetportal@iot-venture.com",
}
